// components/speaker/SpeakerList.js
import { useEffect, useState } from 'react';
import useEventStore, { speakers } from '../../stores/eventStore';
import { Speaker } from './Speaker';
import styles from './speaker.module.scss';

export const SpeakerList = () => {
	const { activeTab } = useEventStore();
	const group = speakers.find((e) => e.topic === activeTab);
	const speakerData = group?.items || [];

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const [activeIndex, setActiveIndex] = useState(null);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const handleToggle = (index) => {
		setActiveIndex((prev) => (prev === index ? null : index));
	};

	const handleHover = (index) => {
		if (!isMobile) setActiveIndex(index);
	};

	const handleLeave = () => {
		if (!isMobile) setActiveIndex(null);
	};

	return (
		<>
			<div className={styles.speakerListWrapper}>
				{speakerData.length === 0 ? (
					<div className={styles.comingSoon}>Coming Soon</div>
				) : (
					<div className={styles.speakerContainer}>
						{speakerData.map((speaker, i) => (
							<Speaker
								key={speaker.name ?? i}
								speaker={speaker}
								index={i}
								isMobile={isMobile}
								isActive={i === activeIndex}
								onToggle={handleToggle}
								onHover={handleHover}
								onLeave={handleLeave}
							/>
						))}
					</div>
				)}
			</div>
		</>
	);
};
